import React,{Component} from "react";

class About extends Component{
    render(){
        return(
            <div class="about" >
<span style={{fontSize:"5vw;"}}><br/><br/><br/><br/>    I am Third Year CSE undergrad student My Passion is For Computers in all kind of Perspectives
				  I love☮ technology/Space/Discovery🌍/spirituality.
                <br/> I write things about Web Development 👉<a href="https://dev.to/krishnakakade" target="_blank">ClickMe</a>
                 I build Projects check 👉<a href="https://github.com/krishnadevz" target="_blank">Github</a>.
                                 Check My regular thoughts 👉<a href="https://twitter.com/krishnadevz" target="_blank">ClickME</a>
                                  Thank You for reaching here Peace always God bless you all.🙏 </span>
				  <span><a class="btn btn-cta-primary float-right" href="mailto:<krishnadevz@protonmail.com?subject=subject text" target="_blank"><i class="fas fa-paper-plane"></i> Contact Me</a>

		      </span>			
		</div>
        )
    }
}
export default About